export const API_CONFIG = {
    baseURL: import.meta.env.VITE_API_BASE_URL || 'https://api-hazert.utilian.com',
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    },
} as const;

// Optional: Create different configs for different flavors
export const getApiBaseUrl = () => {
    return import.meta.env.VITE_API_BASE_URL || 'https://api-hazert.utilian.com';
};